export const POST_MESSAGE_REQUEST = 'POST_MESSAGE_REQUEST';
export const POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
export const POST_MESSAGE_FAILURE = 'POST_MESSAGE_FAILURE';

export const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST';
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE';

export const POST_MESSAGE_SEEN_REQUEST = 'POST_MESSAGE_SEEN_REQUEST';

export const FETCH_CONVERSATION_REQUEST = 'FETCH_CONVERSATION_REQUEST';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_FAILURE = 'FETCH_CONVERSATION_FAILURE';

export const CLEAR_CONVERSATION = 'CLEAR_CONVERSATION';
export const CLEAR_PREVIOUS_CONVERSATION = 'CLEAR_PREVIOUS_CONVERSATION';

export const FETCH_CONVERSATION_FILE = 'FETCH_CONVERSATION_FILE';

export const CONVERSATION_UPLOAD_FILE_POST_INFO = 'CONVERSATION_UPLOAD_FILE_POST_INFO';
export const CONVERSATION_UPLOAD_FILE_SUCCESS = 'CONVERSATION_UPLOAD_FILE_SUCCESS';
export const CONVERSATION_UPLOAD_FILE_FAILURE = 'CONVERSATION_UPLOAD_FILE_FAILURE';
export const CONVERSATION_UPLOAD_FILE_IDLE = 'CONVERSATION_UPLOAD_FILE_IDLE';

export const POST_CONVERSATION_TAGS_REQUEST = 'POST_CONVERSATION_TAGS_REQUEST';
export const POST_CONVERSATION_TAGS_SUCCESS = 'POST_CONVERSATION_TAGS_SUCCESS';
export const POST_CONVERSATION_TAGS_FAILURE = 'POST_CONVERSATION_TAGS_FAILURE';

export const CONVERSATION_ATTACH_FROM_LIBRARY_REQUEST = 'CONVERSATION_ATTACH_FROM_LIBRARY_REQUEST';

export const UPDATE_CONVERSATION_REVIEW = 'UPDATE_CONVERSATION_REVIEW';
